export const Linking9142A = `
... on Form790AAnd790DataDatahub {
    formVersionId
    empIsContractor
    empBusinessName
    empTradeName
    emppocLastname
    emppocFirstname
    emppocMiddlename
    emppocJobtitle
    emppocAddr1
    emppocAddr2
    emppocCity
    emppocState
    emppocPostcode
    emppocPhone
    emppocPhoneext
    emppocEmail
    empFein
    empNaics
    empNaicsDesc
    agBusinesses {
        agricFein
        agricLegalName
        business_id
        agricTradeName
        agricPrevTradeName1
        agricPrevTradeName2
        agricAddress1
        agricAddress2
        agricCity
        agricState
        agricPostalCode
        agricTotalWorkers
    }
}
`;
